
  import { css } from 'lit';
  export const styles = css`:host{--background: var(--ig-tooltip-background, hsl(from var(--ig-gray-900) h s l/0.8));--text-color: var(--ig-tooltip-text-color, var(--ig-gray-900-contrast));--ig-theme: bootstrap;--ig-theme-variant: dark}`;
  